import React from "react";
import { Counter } from "@/components/shared/Counter";
import { StaggerGroup, StaggerItem } from "@/components/shared/Reveal";
import { STATS } from "@/data/site";

export const Stats = () => {
  return (
    <section className="relative bg-brand text-white overflow-hidden" data-testid="stats">
      <div className="grain absolute inset-0" />
      <div className="container-x relative py-16 lg:py-20">
        <StaggerGroup className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6 divide-x-0 lg:divide-x lg:divide-white/10">
          {STATS.map((s) => (
            <StaggerItem key={s.label} className="text-center lg:px-4" data-testid={`stat-${s.label.split(" ")[0].toLowerCase()}`}>
              <div className="font-heading font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl">
                <Counter target={s.target} suffix={s.suffix} />
              </div>
              <p className="mt-3 text-sm sm:text-base text-white/70 uppercase tracking-widest">{s.label}</p>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
